import { Box, styled } from '@mui/material'
import { Avatar } from '@carto/meridian-ds/components'

import defaultImage from 'assets/img/thumbnails-apps-default-carto.svg'

const StyledContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius
}))

const Logo = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(8),
  height: theme.spacing(8)
}))

export default function HomeAppCardLogo({ image, title }: { image?: string; title: string }) {
  return (
    <StyledContainer>
      <Logo src={image || defaultImage} title={title} variant="rounded" />
    </StyledContainer>
  )
}
